import React from "react";
import { ResponsiveFunnel } from "@nivo/funnel";

const theme = {
  grid: {
    line: { stroke: "transparent" },
  },
  labels: {
    text: {
      fontWeight: "bold", // Make arc labels bold
      fontSize: ".8rem",
      fontFamily: '"Exo", sans-serif', // Set font family for arc labels
    },
  },
  tooltip: {
    container: {
      background: "#333",
      color: "#fff", // Set tooltip text color to black
      fontFamily: '"Exo", sans-serif',
    },
  },
};

const NivoFunnel = ({ data, colors }) => {
  const transformedData =
    data?.slice(1)?.map(([id, value]) => ({ id, label: id, value })) || [];

  if (!transformedData.length) {
    return null;
  }
  return (
    <div
      className="pie-chart-container"
      style={{ width: "100%", height: 280, paddingTop: 10 }}
    >
      <ResponsiveFunnel
        data={transformedData}
        margin={{ top: 0, right: 20, bottom: 60, left: 20 }}
        valueFormat=">-.1s"
        colors={colors}
        borderWidth={0}
        labelColor={{
          from: "color",
          modifiers: [["darker", 3]],
        }}
        enableGridX={false}
        beforeSeparatorLength={80}
        beforeSeparatorOffset={20}
        afterSeparatorLength={80}
        afterSeparatorOffset={20}
        currentPartSizeExtension={10}
        currentBorderWidth={40}
        motionConfig="wobbly"
        theme={theme}
      />
    </div>
  );
};

export default NivoFunnel;
